
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorGenericInleftRight100 as ObiThreewayAcuatorGenericInleftRight100Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-generic-inleft-right-100.js';
 
 
 

 
 export const ObiThreewayAcuatorGenericInleftRight100 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-generic-inleft-right-100',
   elementClass: ObiThreewayAcuatorGenericInleftRight100Element,
   events: {
     
   }
  });
 
 